'use client'
import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import useCustomSWR from '@/hook/useCustomSWR';
import { useDebounce } from 'use-debounce';
import { trackUserSearch } from '@/utils/trackUserSearch';
const Search = ({ isBelowHero, pathname, isBuyPage }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const [debouncedSearchValue] = useDebounce(searchValue, 500);

  const [results, setResults] = useState([]);
  const dropdownRef = useRef();
  const resultRef = useRef();
  const [isFocused, setIsFocused] = useState(false);

  const { data: initialSuggestions } = useCustomSWR(`/v1/products/get-top-catgory`, true);
  const { data: suggestion, isLoading } = useCustomSWR(
    debouncedSearchValue
      ? `/v1/products/get-search-suggestion?search=${debouncedSearchValue}`
      : null,
    true
  );

  useEffect(() => {
    if (suggestion?.response) {
      setResults(suggestion.response);
    }
  }, [suggestion]);

  const handleFocus = useCallback(() => {
    setIsFocused(true);
    setIsOpen(true);
    if (initialSuggestions?.response) setResults(initialSuggestions.response);
  }, [initialSuggestions]);

  const handleClickOutside = useCallback((event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
      setResults([]);
    }
  }, []);

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [handleClickOutside]);

  const handleSearch = (e) => {
    e.preventDefault();
    // Implement search functionality if required.
    trackUserSearch(searchValue)
    window.location.href = `/product?search=${searchValue}`;
  };

  const dropdownClasses = useMemo(
    () =>
      `absolute top-1 z-20 mt-10 w-full space-y-2 rounded border bg-white p-2`,
    []
  );

  return (
    <form
      onSubmit={handleSearch}
      className={`relative flex ${isBuyPage ? 'w-3/5' : 'w-full'} ${isBelowHero && pathname === '/' ? 'bg-transparent' : 'bg-white'} shadow-md border rounded-lg `}
    >
      <div
        className="relative flex  w-full items-center"
        ref={dropdownRef}
      >
        <input
          autoComplete="off"
          type="search"
          id="search-dropdown"
          className={`block w-full p-2 text-xs text-black ${isBelowHero && pathname === '/' ? 'bg-transparent' : 'bg-white'
            }  rounded-l-lg focus:outline-none`}
          placeholder="Search with category, product..."
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
          onKeyPress={(e) => e.key === 'Enter' && handleSearch(e)}
          onFocus={handleFocus}
          required
        />
        <button
          type="submit"
          className="rounded-r-lg bg-black p-2 text-sm font-medium text-white"
        >
          <svg
            className="h-full w-4"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 20 20"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
            />
          </svg>
        </button>

        {results.length > 0 && !isLoading && isOpen && (
          <div className={dropdownClasses} ref={resultRef}>
            <div className="overflow-y-auto">
              {results.map((item, index) => (
                <a
                  key={index}
                  href={
                    item.type === 'product'
                      ? `/product?search=${item.name}`
                      : `/product?name=${item.type}&id=${item.type_id}`
                  }
                  onClick={() => {
                    trackUserSearch(item.name)
                  }}
                  className="block p-1 text-xs text-gray-600 no-underline hover:bg-gray-300 hover:text-gray-900"
                >
                  {item.name}
                </a>
              ))}
            </div>
          </div>
        )}
      </div>
    </form>
  );
};

export default Search;
